import React from "react";
import { CircularProgress } from "@mui/material";
import cx from "classnames";
import "./Preloader.css";

const Preloader = (props) => {
    const {
        isLoading, children, size, overflow,
        showInitiallyOverflow,
    } = props;

    if (overflow && (isLoading || showInitiallyOverflow)) {
        return (
            <div className={cx("PreloaderWrapper", { "PreloaderWrapper--active": isLoading })}>
                {children}
                {isLoading && (
                    <div className="PreloaderCircleBox">
                        <CircularProgress
                            className="Preloader"
                            size={size || null}
                        />
                    </div>
                )}
            </div>
        );
    }

    if (isLoading) {
        return (
            <CircularProgress
                className="Preloader"
                size={size || null}
            />
        );
    }

    return children;
};

export default Preloader;
